import { DROP_UPLOAD_CODES_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import pipe from 'ramda/src/pipe'
import assoc from 'ramda/src/assoc'
import assocPath from 'ramda/src/assocPath'
import dropUploadCodesPayloadSchema	from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/dropUploadCodesPayloadSchema'
import { ACCOUNT_SETTINGS_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'

export const dropUploadCodesFields = [
	{
		fieldId: 'name',
		inputType: 'text',
		placeholder: 'Super Cable Boy Soundtrack',
		labelFieldText: [
			{
				text: 'Display Name',
			},
		],
		required: true,
	},
	{
		fieldId: 'url',
		inputType: 'text',
		placeholder: 'https://store.steampowered.com/app/1496630/Super_Cable_Boy_Soundtrack/',
		labelFieldText: [
			{
				text: 'Landing page url',
			},
		],
		subFieldText: 'Where creators go to redeem the code or coupon',
		required: true,
	},
	{
		fieldId: 'csvCodes',
		inputType: 'attachmentInput',
		attachmentFormats: ['csv', 'txt'],
		subFieldText: 'Coupon/code .csv or .txt upload (one column, no header)',
		required: true,
	},
]

export default {
	[DROP_UPLOAD_CODES_FORM_MODULE_ID]: {
		moduleType: 'form',
		title: 'Upload Codes',
		schema: pipe(
			assoc('required', ['url', 'name']),
			assocPath(['properties', 'csvCodes'], {}),
		)(dropUploadCodesPayloadSchema),
		fields: dropUploadCodesFields,
		submits: [
			{
				label: 'Upload',
				buttonType: 'primaryButton',
			},
		],
		links: [
			{
				routeId: ACCOUNT_SETTINGS_ROUTE_ID,
				label: 'Go Back',
				dynamicPreviousRoute: true,
			},
		],
	},
}
